<mat-sidenav-container class="sidenav-container">
  <button mat-icon-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-sidenav #sidenav class="sidenav" fixedInViewport="false" [mode]="(isHandset$ | async) ? 'over' : 'side'" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [opened]="(isHandset$ | async) ? false : true">
    <mat-nav-list>
      <a mat-list-item routerLink="/SuperAdminHome">Home</a>
      <a mat-list-item routerLink="/addcompany">Add Company</a>
      <a mat-list-item routerLink="/managecompanies">Manage Companies</a>
      <a mat-list-item routerLink="/reports">Reports</a>
      <a mat-list-item (click)="logout()">Logout</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
      <div >
          <mat-toolbar class="example-toolbar">
              <mat-toolbar-row>
                <button mat-icon-button (click)="sidenav.toggle()">
                  <mat-icon>menu</mat-icon>
                </button>
                <!-- <h1>Able Trace</h1> -->
                <img src="../../assets/images/AbleTraceLogo.png" alt="logo" width="200px" height='50px' [routerLink]="'/AdminHome'">

             <div class="container-fluid">
                  <div class="d-flex flex-row justify-content-end align-items-center">
                      <p class="username" style="font-size:medium;padding-top: 15px;">Hi {{name}} <span *ngIf="company_name && company_name.trim().length > 0">({{company_name}})</span> ! </p>&nbsp;&nbsp;&nbsp;
                          <button mat-button [matMenuTriggerFor]="menu" class="pointer">
                            <mat-icon style="cursor:pointer; width:24px; height:24px; font-size: 24px;"> account_circle </mat-icon>
                          </button>
                          <button mat-button [matMenuTriggerFor]="menu" (click)="logout()">
                            <mat-icon style="cursor:pointer;"> logout </mat-icon>
                          </button>
                                <mat-menu #menu="matMenu">
                                  <button mat-menu-item  [routerLink]="'/Profile-details'">Profile</button>
                                  <button mat-menu-item  [routerLink]="'/Change-pwd'" >Change Password</button>
                                </mat-menu>
                   </div>
             </div>
              </mat-toolbar-row>
              <!-- <mat-toolbar-row>
                  <span class="menu-spacer"></span>
                <div>
                  <a mat-button [routerLink]="'/accounts'"> Accounts </a>
                  <a mat-button [routerLink]="'/create-account'"> Create Account </a>
                  <a mat-button [routerLink]="'/contacts'"> Contacts </a>
                </div>
                </mat-toolbar-row> -->
            </mat-toolbar>
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
